import { IStaticAccordion } from "../../../../Contracts/StaticDataAccordion";
import { LegislationSections } from "../../../Model/Enum/BEE123Enums";

export const BBBEE_Legislation: Array<IStaticAccordion> = [
    {
        title: "Codes of Good Practice",
        groups: [
          {
            title: "Revised Codes",
            items: [
              {
                title: "Revised B-BBEE Codes of Good Practice (October 2013)",
                link:
                  "Revised B-BBEE Codes of Good Practice(October2013).pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "Amendment to the Revised B-BBEE Codes of Good Practice (6 May 2015)",
                link:
                  "Revised B-BBEE Codes of Good Practice_additions(6May2015).pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "Revised B-BBEE Codes Phase 2 (QSEs, Sector Charter Development, Specialised Entities, Sale of Assets, Multinational Equity Equivalents) (6 May 2015)",
                link:
                  "Revised B_BBEE Codes of Good Practice (Phase 2) Gazetted(6May2015).pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "Youth Employment Service (Y.E.S) Initiative (28 August 2018)",
                link:
                  "Youth_Employment_Service_(Y.E.S)_Initiative_(28_August_2018).pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "Amended Code Series 000 (Notice 306 of 2019_31 May 2019)",
                link:
                  "Amended_Code_Series_000_(Notice_306_of_2019_31_May_2019).pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "Amended Code Series 300 (Notice 305 of 2019_31 May 2019)",
                link:
                  "Amended_Code_Series_300_(Notice_305_of_2019_31_May_2019).pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "Amended Code Series 400 (Notice 304 of 2019_31 May 2019)",
                link:
                  "Amended_Code_Series_400_(Notice_304_of_2019_31_May_2019).pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "Amended Schedule 1 (Notice 303 of 2019_31 May 2019)",
                link:
                  "Amended_Schedule_1_(Notice_303_of_2019_31_May_2019).pdf",
                section: LegislationSections.BBBEE
              },
            ],
          },
          {
            title: "Original Codes",
            items: [
              {
                title: "B-BBEE Codes of Good Practice",
                link:
                  "CODES OF GOOD PRACTICE/DTI B-BBEE Codes Final.pdf",
                section: LegislationSections.BBBEE
              },
            ],
          },
        ],
      },
      {
        title: "Sector Codes",
        groups: [
          {
            title: "Revised Sector Codes",
            items: [
              {
                title: "Revised Tourism Sector Codes (20 November 2015)",
                link:
                  "SectorCodes/Tourism_Amended_Sector_Code_Gazette_No_39430_20_November_2015.pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Revised MAC Sector Codes (1 April 2016)",
                link:
                  "SectorCodes/Revised MAC Sector Codes_Gazetted 1 April 2016.pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Revised ICT Sector Codes (07 November 2016)",
                link:
                  "SectorCodes/Revised_ICT_Sector_Codes_(07_November_2016).pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Revised Forest Sector Codes (21 April 2017)",
                link:
                  "SectorCodes/FORESTRY_SC_21_APRIL_2017_GAZETTE_40803.pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Revised Property Sector Codes (09 June 2017)",
                link:
                  "SectorCodes/Revised_Property_Sector_Codes_(09_June_2017).pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Revised Mining and Minerals Sector Codes (15 June 2017)",
                link:
                  "SectorCodes/Revised_Mining_and_Minerals_Sector_Codes_(15_June_2017).pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Revised FSC Sector Charter (01 December 2017)",
                link:
                  "SectorCodes/Revised_FSC_Sector_Charter_(01_December_2017).pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Revised Construction Charter (01 December 2017)",
                link:
                  "SectorCodes/Revised_Construction_Sector_Codes_Gazetted_01_December_2017.pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Revised Agri Sector Codes (08 December 2017)",
                link:
                  "SectorCodes/Revised_Agri_Sector_Codes_(8_December_2017).pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Defence Sector Codes (12 April 2019)",
                link:
                  "SectorCodes/Revised_Defence_Sector_Codes_(12_April_2019).pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Mining and Minerals Sector Charter (27 September 2018)",
                link:
                  "SectorCodes/Mining_and_Minerals_Sector_Charter_(27_September_2018).pdf",
                section: LegislationSections.CHARTERS,
                subItem: [
                  {
                    title: "Amendment of the Mining Charter (20 December 2018)",
                    link:
                      "SectorCodes/Amendment_of_the_Mining_Charter_(20_December_2018).pdf",
                    section: LegislationSections.CHARTERS
                  },
                ],
              },
              {
                title: "Legal Sector Codes (20 September 2024)",
                link:
                  "SectorCodes/Legal_Sector_Codes_(20_September_2024).pdf",
                section: LegislationSections.CHARTERS
              },
            ],
          },
          {
            title: "Draft Revised Sector Codes",
            items: [
              {
                title: "Draft Revised Transport Sector Codes (26 February 2016)",
                link:
                  "SectorCodes/Gazette_39744_26_2_Transport_BBBEE_Code_Draft.01.pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Draft Legal Sector Code (22 July 2022)",
                link:
                  "SectorCodes/broad-based-black-economic-empowerment-act-b-bbee-act-53-2003-draft-legal-sector-code.pdf",
                section: LegislationSections.CHARTERS
              },
            ],
          },
          {
            title: "Draft Amended Sector Codes",
            items: [
              {
                title: "Draft Amended Tourism B-BBEE Sector Code",
                link:
                  "SectorCodes/Draft_Tourism_B-BBEE_Codes.pdf",
                section: LegislationSections.CHARTERS
              },
            ],
          },
          {
            title: "Original Sector Codes",
            items: [
              {
                title: "AgriBEE Sector Charter",
                link:
                  "Sector Codes gazetted under Section 9(1)/Agricultural Sector Charter.pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Chartered Accountancy Charter",
                link:
                  "Sector Codes gazetted under Section 9(1)/Draft Chartered Accountancy Charter/Chartered Accountancy Charter.pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Construction Sector Charter",
                link:
                  "Sector Codes gazetted under Section 9(1)/Construction Sector Charter.pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Financial Sector Charter",
                link:
                  "Sector Codes gazetted under Section 9(1)/Financial_sector_code.pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Forest Sector Charter Pages 1-24",
                link:
                  "Sector Codes gazetted under Section 9(1)/Forest Sector Charter_Pages 1-24.pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Forest Sector Charter Pages 25-36",
                link:
                  "Sector Codes gazetted under Section 9(1)/Forest Sector Charter_Pages 25-36.pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Information and Communication Technology (ICT) Charter",
                link:
                  "Sector Codes gazetted under Section 9(1)/ICT Sector Charter.pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Property Sector Charter",
                link:
                  "Sector Codes gazetted under Section 9(1)/Property Sector Charter.pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Tourism Sector Charter",
                link:
                  "Sector Codes gazetted under Section 9(1)/Tourism Sector Charter.pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Transport Sector Charter",
                subItem: [
                  {
                    title:
                      "Bus Commuter and Coach Services Sub-Sector Code Page 13-28",
                    link:
                      "Sector Codes gazetted under Section 9(1)/Transport Sector Charter/Bus Commuter and Coach Services Sub-Sector Code_Page13-28.pdf",
                    section: LegislationSections.CHARTERS
                  },
                  {
                    title:
                      "Bus Commuter and Coach Services Sub-Sector Code Page 29-38",
                    link:
                      "Sector Codes gazetted under Section 9(1)/Transport Sector Charter/Bus Commuter and Coach Services Sub-Sector Code_Page29-38.pdf",
                    section: LegislationSections.CHARTERS
                  },
                  {
                    title: "Domestic Aviation Sub-Sector Code Page 207-224",
                    link:
                      "Sector Codes gazetted under Section 9(1)/Transport Sector Charter/Domestic Aviation Sub-Sector Code_Page207-224.pdf",
                    section: LegislationSections.CHARTERS
                  },
                  {
                    title: "Domestic Aviation Sub-Sector Code Page 225-232",
                    link:
                      "Sector Codes gazetted under Section 9(1)/Transport Sector Charter/Domestic Aviation Sub-Sector Code_Page225-232.pdf",
                    section: LegislationSections.CHARTERS
                  },
                  {
                    title: "Forwarding and Clearing Sub-Sector Code Page 161-177",
                    link:
                      "Sector Codes gazetted under Section 9(1)/Transport Sector Charter/Forwarding and Clearing Sub-Sector Code_Page161-177.pdf",
                    section: LegislationSections.CHARTERS
                  },
                  {
                    title: "Forwarding and Clearing Sub-Sector Code Page 178-185",
                    link:
                      "Sector Codes gazetted under Section 9(1)/Transport Sector Charter/Forwarding and Clearing Sub-Sector Code_Page178-185.pdf",
                    section: LegislationSections.CHARTERS
                  },
                  {
                    title: "General Notice, Preamble and Definitions Page 1-12",
                    link:
                      "Sector Codes gazetted under Section 9(1)/Transport Sector Charter/General Notice, Preamble and Definitions _ Page 1-12.pdf",
                    section: LegislationSections.CHARTERS
                  },
                  {
                    title:
                      "Maritime Transport and Services Industry Sub-Sector Code Page 129-147",
                    link:
                      "Sector Codes gazetted under Section 9(1)/Transport Sector Charter/Maritime Trans and Services Ind SubSector Code_Pg129-147.pdf",
                    section: LegislationSections.CHARTERS
                  },
                  {
                    title:
                      "Maritime Transport and Services Industry Sub-Sector Code Page 148-160",
                    link:
                      "Sector Codes gazetted under Section 9(1)/Transport Sector Charter/Maritime Trans and Services Ind SubSector Code_Pg148-160.pdf",
                    section: LegislationSections.CHARTERS
                  },
                  {
                    title: "Public Sub-Sector Code - Transport Page 94-110",
                    link:
                      "Sector Codes gazetted under Section 9(1)/Transport Sector Charter/Public Sub-Sector Code - Transport_Page94-110.pdf",
                    section: LegislationSections.CHARTERS
                  },
                  {
                    title: "Public Sub-Sector Code - Transport Page 111-128",
                    link:
                      "Sector Codes gazetted under Section 9(1)/Transport Sector Charter/Public Sub-Sector Code - Transport_Page111-128.pdf",
                    section: LegislationSections.CHARTERS
                  },
                  {
                    title: "Rail Sub-Sector Code Page 186-199",
                    link:
                      "Sector Codes gazetted under Section 9(1)/Transport Sector Charter/Rail Sub-Sector Code_Page186-199.pdf",
                    section: LegislationSections.CHARTERS
                  },
                  {
                    title: "Rail Sub-Sector Code Page 200-206",
                    link:
                      "Sector Codes gazetted under Section 9(1)/Transport Sector Charter/Rail Sub-Sector Code_Page200-206.pdf",
                    section: LegislationSections.CHARTERS
                  },
                  {
                    title: "Road Freight Sub-Sector Code Page 67-80",
                    link:
                      "Sector Codes gazetted under Section 9(1)/Transport Sector Charter/Road Freight Sub-Sector Code_Page67-80.pdf",
                    section: LegislationSections.CHARTERS
                  },
                  {
                    title: "Road Freight Sub-Sector Code Page 81-93",
                    link:
                      "Sector Codes gazetted under Section 9(1)/Transport Sector Charter/Road Freight Sub-Sector Code_Page81-93.pdf",
                    section: LegislationSections.CHARTERS
                  },
                  {
                    title: "Taxi Industry Sub-Sector Code Page 39-56",
                    link:
                      "Sector Codes gazetted under Section 9(1)/Transport Sector Charter/Taxi Industry Sub-Sector Code_Page39-56.pdf",
                    section: LegislationSections.CHARTERS
                  },
                  {
                    title: "Taxi Industry Sub-Sector Code_Page 57-66",
                    link:
                      "Sector Codes gazetted under Section 9(1)/Transport Sector Charter/Taxi Industry Sub-Sector Code_Page57-66.pdf",
                    section: LegislationSections.CHARTERS
                  },
                ],
              },
              {
                title:
                  "Marketing, Advertising and Communication (MAC) Sector Charter",
                link:
                  "Sector Charters gazetted under Section 12/Marketing, Advertising and Communication (MAC) Sector Charter.pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Petroleum & Liquid Fuels Industry Charter",
                link:
                  "Charters Gazetted under the Mineral and Petroleum Resources Development Act/Petroleum and Liquid Fuels Industry Charter.pdf",
                section: LegislationSections.CHARTERS
              },
              {
                title: "Mining Charter",
                subItem: [
                  {
                    title: "Amended of BBSEE Charter",
                    link:
                      "Charters Gazetted under the Mineral and Petroleum Resources Development Act/Mining Charter/Amended_of_BBSEE_Charter.pdf",
                    section: LegislationSections.CHARTERS
                  },
                  {
                    title: "Employment Equity",
                    link:
                      "Charters Gazetted under the Mineral and Petroleum Resources Development Act/Mining Charter/Employment_Equity.pdf",
                    section: LegislationSections.CHARTERS
                  },
                  {
                    title: "HRD Template",
                    link:
                      "Charters Gazetted under the Mineral and Petroleum Resources Development Act/Mining Charter/HRD_Templete.pdf",
                    section: LegislationSections.CHARTERS
                  },
                  {
                    title: "Reporting Template",
                    link:
                      "Charters Gazetted under the Mineral and Petroleum Resources Development Act/Mining Charter/Reporting_Template.pdf",
                    section: LegislationSections.CHARTERS
                  },
                  {
                    title: "Scorecard",
                    link:
                      "Charters Gazetted under the Mineral and Petroleum Resources Development Act/Mining Charter/scorecard.pdf",
                    section: LegislationSections.CHARTERS
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        title: "Acts",
        groups: [
          {
            items: [
              {
                title: "B-BBEE Amendment Act (January 2014)",
                link:
                  "B-BBEE Amendment Act (January2014).pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "B-BBEE Regulations to the ACT (June 2016)",
                link:
                  "B-BBEE_Regulations_to_the_ACT.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "Broad-Based Black Economic Empowerment Act, 53 of 2003",
                link: "BB_BEE Act.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "PPPFA Preferential Procurement Regulations",
                link:
                  "PPPFA_Preferential Procurement Regulations.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "Draft Preferential Procurement Regulations 2016 (14 June 2016)",
                link:
                  "National_Treasury_-_Draft_Preferential_Procurement_Regulations_2016.pdf",
                section: LegislationSections.BBBEE
              },
            ],
          },
        ],
      },
      {
        title: "Notices & Other Documents",
        groups: [
    
          {
            title: "General",
            items: [
              {
                title:
                  "Practice Note - Rules for Discretionary Collective Enterprises (18 May 2021)",
                link:
                  "dticPractice_NoteB-BBEEActRulesDiscretionaryCollectiveEnterprises18052021.pdf",
                 section: LegislationSections.BBBEE
              },
              {
                title:
                  "Notice 748 of 2016 - Thresholds for Major B-BBEE Transactions",
                link:
                  "Notice_748_of_2016_-_Thresholds_for_Major_B-BBEE_Transactions.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "Notice 707 of 2016 - Empowering Supplier Status",
                link:
                  "Notice_707_of_2016_-_Empowering_Supplier_Status.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "Notice 444 of 2015 - Clarification of the Transitional Period for the Revised Codes (15 May 2015)",
                link:
                  "Notice 444 of 2015_Revised Clarification.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "Extension of Transitional Period for the Revised Codes",
                link:
                  "Notice 226_Extention of Transitional Period (Revised Codes).pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "Repeal of Sector Codes (17 February 2016)",
                link:
                  "National_Gazette_No_39703_Volume_608_Repeal_of_Sector_Codes_17_February_2016.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "Statement of Clarification – Repeal of Sector Codes (22 February 2016)",
                link:
                  "Clarification_Repealed_Sector_Codes.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "Notice 551 of 2017 - Threshold for Major B-BBEE Transactions (09 June 2017)",
                link:
                  "Notice_551_of_2017_-_Threshold_for_Major_B-BBEE_Transactions_(09_June_2017).pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "Notice 374 of 2018 - Memorandum of Understanding between SARS and the B-BBBEEE Commission",
                link:
                  "Notice_374_of_2018_-_MOU_between_SARS_and_BBBEE_Commission.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "Notice 640 of 2018 - Youth Employment Service (Y.E.S) Initiative",
                link:
                  "Notice_640_of_2018_-_Youth_Employment_Service_(Y.E.S)_Initiative.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "Guidelines - Complex Structures Fronting",
                link:
                  "GuidelinesComplexstructuresFronting.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "Interpretative Guidelines",
                link:
                  "Interpretative Guidelines.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "Guidelines - Multi National Equity Equivalent",
                link:
                  "Multi National Equity Equivalent Guidelines.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "Clarification to the Youth Employment Service Initiative Practice Note of 2019 (Gazette 41975)",
                link:
                  "Clarification_Statement_for_the_Y.E.S_Initiative_-_24_February_2020.pdf",
                section: LegislationSections.BBBEE
              },
            ],
          },
          {
            title: "ICT Sector",
            items: [
              {
                title:
                  "Revised ICT Sector Codes - Clarification of Effective Date (7 December 2016)",
                link:
                  "Revised_ICT_Sector_Codes_-_Clarification_of_Effective_date.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "ICT Council - Private Sector Contribution Fees (07 May 2020)",
                link:
                  "ICT_Council__2020_Private_Sector_Contribution_Fees_07_May_2020.02.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "Reminder ICT Council Private Sector Contribution Fees 3GCM2 - 29 September 2020",
                link:
                  "Reminder_ICT_Council_Private_Sector_Contribution_Fees_3GCM2_-_29_September_2020.jpg",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "Clarification ICT Council Private Sector Contribution Fees 3GCM2 - 03 September 2020",
                link:
                  "Clarification_ICT_Council_Private_Sector_Contribution_Fees_3GCM2_-_03_September_2020.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "4GCM2-3.4 Reminder to Measured Entity Representatives to submit B-BBEE Certificate",
                link:
                  "4GCM2-3.4_Reminder_to_Measured_Entity_Representatives_to_submit_B-BBEE_Certificate.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "FAQs ICT Council Private Sector Contribution Fees 2GCM2 - 03 August 2020",
                link:
                  "FAQs_ICT_Council_Private_Sector_Contribution_Fees_2GCM2_-_03_August_2020.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "201920 ICT Council Private Sector Contribution Fees 2GCM2 - 07 May 2020",
                link:
                  "201920_ICT_Council_Private_Sector_Contribution_Fees_2GCM2_-_07_May_2020.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "Private Sector Contribution Model Annual Fees Reviewed 2020/2021 - 7 June 2021",
                link: "5GCM2_(202106071230)_ICT_COUNCIL_PSC_MODEL_FEES_2021.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "Reminder ICT Council Private Sector Contribution Fees 17GCM3 - 17 July 2024",
                link: "Reminder_ICT_Council_Private_Sector_Contribution_Fees_17GCM3_17_July_2024.pdf",
                section: LegislationSections.BBBEE
              },
            ],
          },
          {
            title: "Construction Sector",
            items: [
              {
                title:
                  "Construction Sector - Guidelines for Nominal Fees for Verification of QSEs and EMEs (April 2018)",
                link:
                  "Finalized_Reviewed_Nominal_Fee_Structure_For_EME_and_QSEs_-_April_2018.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "Construction Sector - Guidelines for the Uptake of Verification Agencies",
                link:
                  "Reviewed_Verification_Undertaking_-_March_2018.pdf",
                section: LegislationSections.BBBEE
              },
            ],
          },
          {
            title: "FSC Sector",
            items: [
              {
                title: "FSC CN000(1) - Application of the B-BBEE Recognition Levels Formula (10 March 2021)",
                link:
                  "Clarification_Note_CN000(1)_-_Updated_10th_March_2021.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "FSC GN-200 - Management - Update of Targets",
                link:
                  "FSC_GN200-Management-Update_of_Targets.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "FSC GN600(a) - Transformational infrastructure",
                link:
                  "FSC_GN600(a)_-_Transformational-infrastructure.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "FSC GN600(b) - Affordable Housing Standards",
                link:
                  "FSC_GN600(b)-Affordable-Housing-Standards.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "FSC GN600(c) - empowerment financing",
                link:
                  "FSC_GN600(c)_-_empowerment-financing.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "FSC GN600(d) - Black SME Financing",
                link:
                  "FSC_GN600(d)_-_Black-SME-Financing.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "FSC GN600(e) - Enterprise Supplier Dev",
                link:
                  "FSC_GN600(e)_-_Enterprise-Supplier-Dev.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "FSC GN600(f) - Business growth funding",
                link:
                  "FSC_GN600(f)_-_Business-growth-funding.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "FSC - GN700a - The Measurement of Access to Financial Services - Banks",
                link:
                  "FSC_-_GN700a_-_The_Measurement_of_Access_to_Financial_Services_-_Banks.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "FSC - GN700aa - The Measurement of Access to Financial Services - Banks",
                link:
                  "FSC_-_GN700aa_-_The_Measurement_of_Access_to_Financial_Services_-_Banks.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "FSC - GN700ab - The Measurement of Access to Financial Services - Banks - Electronic Access",
                link:
                  "FSC_-_GN700ab_-_The_Measurement_of_Access_to_Financial_Services_-_Banks_-_Electronic_Access.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "FSC - GN700b - Thea Measurement of Access to Financial Services - Long - term Assurers",
                link:
                  "FSC_-_GN700b_-_Thea_Measurement_of_Access_to_Financial_Services_-_Long-term_Assurers.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "FSC - GN700c - The Measurement of Access to Financial Services - Short term Insurers",
                link:
                  "FSC_GN700c_-The_Measurement_of_Access_to_Financial_Services_-_Short-term_Insurers.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "FSC - GN800(a) - Consumer Education",
                link:
                  "FSC_-_GN800(a)_-_Consumer_Education.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "Notice by the Financial Sector Transformation Council - Annual Reporting",
                link:
                  "FSTC_2018_2019_Reporting_Letter.pdf",
                section: LegislationSections.BBBEE
              },
            ],
          }, {
            title: "Agri Sector",
            items: [
              {
                title:
                  "Principles for Recognition of the Industry Levy Contribution towards Collective and Industry driven B-BBEE Interventions in the Sugar Industry",
                link:
                  "AgriBEE_Guidance_Note_-_Principles_for_recognition_of_industry_levy_contributions_in_the_Sugar_Industry__final.pdf",
                section: LegislationSections.BBBEE
              }
            ],
          },
          {
            title: "Tourism Sector",
            items: [
              {
                title:
                  "Memorandum of Understanding between The Dep of Economic Development, Tourism and Environmental Affairs and B-BBEE Commission",
                link:
                  "Memorandum_of_Understanding_between_The_Dep_of_Economic_Development,_Tourism_and_Environmental_Affairs_and_B-BBEE_Commission.pdf",
                section: LegislationSections.BBBEE
              },
            ],
          },
          {
            title: "LSC Sector",
            items: [
              {
                title:
                  "LSCC Clarification Notice 1 of 2026",
                link:
                  "LSCC - CLARIFICATION NOTICE NO 1 OF 2026.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "LPC’s Frequently Asked Questions 21 February 2025",
                link:
                  "FREQUENTLY ASKED QUESTIONS 21 February 2025.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "LSCC Notice to Legal Practitioners 22 April 2025",
                link:
                  "LSCC Notice to Legal Practictioners - 22 April 2025 (002).pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "LSCC CN001 of 2025 published 30 June 2025",
                link:
                  "LSCC - CN01 of 2025.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "LSCC Measurement Guidance Notice 01 of 2025",
                link:
                  "Legal Sector Codes of Good Practice - Measurement Guidance Notice 01 of 2025.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "B-BBEE Commissioner: Understanding the Legal Sector Code 26 September 2025",
                link:
                  "Understanding the legal sector code 26 09 25.pdf",
                section: LegislationSections.BBBEE
              },
            ],
          },
        ],
      },
      {
        title: "B-BBEE Commissioner's Publications",
        groups: [
          {
            title: "Practice Guides ",
            items: [
              {
                title: "Practice Guide 01 of 2016 - Third Party Procurement",
                link:
                  "Practice_Guide_01_of_2016_-_Third_Party_Procurement.pdf",
                section: LegislationSections.Practice_Guides
              },
              {
                title:
                  "Practice Guide 02 of 2016 - BEE Certificates for EMEs and QSEs",
                link:
                  "Practice_Guide_02_of_2016_-_BEE_Certificates_for_EMEs_and_QSEs.pdf",
                section: LegislationSections.Practice_Guides
              },
              {
                title:
                  "Practice Guide 01 of 2017 - Modified Flow Through Principle",
                link:
                  "Practice-Guide-01-of-2017-Modified-Flow-Through-Principle.pdf",
                section: LegislationSections.Practice_Guides
              },
              {
                title:
                  "Practice Guide 02 of 2017 - Application of the 2007 Codes of Good Practice",
                link:
                  "Practice-Guide-02-of-2017-Application-of-the-Old-Generic-Codes.pdf",
                section: LegislationSections.Practice_Guides
              },
            ],
          },
          {
            title: "Notices",
            items: [
              {
                title:
                  "Brochure on Specialised Scorecard_06 September 2021",
                link: "Brochure_on_Specialised_Scorecard_06_September_2021.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "Explanatory Notice 1 of 2019 Submission of Information in Relation to a B-BBEE Compliance Report for Section 13 G (3)",
                link: "Explanatory_Notice_1_of_2019_B-BBEE_Skills_Development_Spending.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "Explanatory Notice 2 of 2021 Guidelines on Completion of Compliance Matrix",
                link: "Explanatory_Notice_2_of_2021_Guidelines_on_Completion_of_Compliance_Matrix.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "Explanatory Notice 1 of 2021 Guidelines on Completion of Compliance Matrix (03 February 2021)",
                link: "Explanatory_Notice_1_of_2021_Guidelines_on_Completion_of_Compliance_Matrix._03_February_2021.pdf",
                section: LegislationSections.BBBEE
              },
              {
                title:
                  "Explanatory Notice 1 of 2017 B BBEE Transactions Registration (13 June 2017)",
                link:
                  "Explanatory-Notice-1-of-2017-B-BBEE-Transactions-Registration_(13_June_2017).pdf",
                section: LegislationSections.BBBEE
              },
              {
                title: "Explanatory Notice 1 of 2016 Issuing Advisory Opinions",
                link:
                  "Explanatory_Notice_1_of_2016_Issuing_Advisory_Opinions.pdf",
                section: LegislationSections.Practice_Guides
              },
              {
                title: "Explanatory Notice 2 of 2017 B-BBEE Compliance Reporting",
                link:
                  "Explanatory_Notice_2_of_2017_B-BBEE_Compliance_Reporting.pdf",
                section: LegislationSections.Practice_Guides
              },
              {
                title: "Compliance Report Template (November 2017)",
                link:
                  "Compliance_Report_Template_(November_2017).pdf",
                section: LegislationSections.Templates
              },
            ],
          },
          {
            title: "Newsletters",
            items: [
              {
                title: "The Whistle First Edition September 2016",
                link:
                  "First_Edition_September_2016.pdf",
                section: LegislationSections.Newsletters
              },
              {
                title: "The Whistle Second Edition January 2017",
                link:
                  "Second_Edition_January_2017.pdf",
                section: LegislationSections.Newsletters
              },
              {
                title: "The Whistle Third Edition April 2017",
                link:
                  "Third_Edition_April_2017.pdf",
                section: LegislationSections.Newsletters
              },
              {
                title: "The Whistle Fourth Edition September 2017",
                link:
                  "The_Whistle_4th_Edition_September_2017.pdf",
                section: LegislationSections.Newsletters
              },
              {
                title: "The Whistle Fifth Edition April 2021",
                link: "The_Whistle_5th_Edition_14 April_Proof A4.pdf",
                section: LegislationSections.Newsletters
              },
              {
                title: "The Whistle Sixth Edition January 2022",
                link: "The_Whistle_6th_Edition_16_02_22.pdf",
                section: LegislationSections.Newsletters
              },
            ],
          },
          {
            title: "Media Releases",
            items: [
              {
                title:
                  "148 Major B-BBEE Transactions submitted to the B-BBEE Commission (1 September 2017)",
                link:
                  "Major_B-BBEE_Transations_1_September_2017.pdf",
                section: LegislationSections.Media_Releases
              },
              {
                title:
                  "National Status and Trends on B-BBEE Transformation Report 2021",
                link:
                  "B-BBEE-NATIONAL-STATUS-AND-TRENDS-ON-B-BBEE-TRANSFORMATION-JULY-SP-Final.pdf",
                section: LegislationSections.Newsletters
              },
            ],
          },
        ],
      },
      {
        title: "Verification",
        groups: [
          {
            items: [
              {
                title: "Notification to all Verification Agencies regarding SANAS Assessing the Submission of B-BBEE Certificates and Reports to Sector Councils",
                link:
                  "SANAS_Notification_Submission_to_Sector_Council_2023_09_08.pdf",
                section: LegislationSections.Verification
              },
              {
                title: "Draft Amended Verification Manual (6 November 2015)",
                link:
                  "Draft_Amended_Verification_Manual_(6_November_2015).pdf",
                section: LegislationSections.Verification
              },
              {
                title:
                  "Verification  Agency and Approved Registered Auditors Requirements",
                link:
                  "Verfication Agency and Approved Registered Auditors Requirements.pdf",
                section: LegislationSections.Verification
              },
              {
                title: "Verification Manual",
                link:
                  "VerificationManual.pdf",
                section: LegislationSections.Verification
              },
              {
                title: "SANAS Documents",
                subItem: [
                  {
                    title: "Application for accreditation",
                    link:
                      "SANAS Docs/Application for accreditation.pdf",
                    section: LegislationSections.Verification
                  },
                  {
                    title: "R47 Document",
                    link:
                      "SANAS Docs/R47.pdf",
                    section: LegislationSections.Verification
                  },
                  {
                    title: "Verification Agency Assessment Process",
                    link:
                      "SANAS Docs/Verification Agency Assessment Process.pdf",
                    section: LegislationSections.Verification
                  },
                  {
                    title: "Verification Agency checklist",
                    link:
                      "SANAS Docs/Verification Agency checklist.pdf",
                    section: LegislationSections.Verification
                  },
                ],
              },
            ],
          },
        ],
      },
  ];
  